/**
 * Logs a message when debug mode is turned on.
 * @param {any} message The message to output
 */
export var logMessage = function logMessage(message) {
  if (GeneralMills.debugMode === true && message) {
    console.log(message);
  }
};